<knk-dynamic-section-standalone
  [config]="config"
  [refreshTrigger]="refreshTrigger()"
  [label]="'dynamicEditor.views' | translate"
/>
